import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import gsap from 'gsap';

export default function relatedSlider() {
    const slider = document.querySelector('.related__slider');
    if (!slider) {
        return;
    }

    let sliderArgs = {
        slidesPerView: 1.1,
        spaceBetween: 20,
        loop: true,
        modules: [Navigation],
        navigation: {
            nextEl: '.related__navigation .related__navigation-next',
            prevEl: '.related__navigation .related__navigation-prev',
        },
        breakpoints: {
            440: {
                slidesPerView: 1.5,
            },
            1024: {
                slidesPerView: 1.5,
            },
            1440: {
                slidesPerView: 2.5,
            },
        },
    };

    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper('.related__slider', sliderArgs);

    // Initialize hover effect for each post card
    // const postCards = document.querySelectorAll('.card-post');
    // postCards.forEach((card) => {
    //     cardHover(card);
    // });

    const postsContainer = document.querySelector('.related__posts .swiper');
    if (postsContainer) {
        cardHover(postsContainer);
    }
}

function cardHover(postCard) {
    const ctaCircle = document.createElement('div');
    ctaCircle.className = 'cta-circle';
    const ctaInner = document.createElement('div');
    ctaInner.className = 'cta-circle__inner';
    const svgs = `<svg class="cta-circle__prev" width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M10.8384 23.1792L1.00015 12.7484L1.05193 11.3759L11.5115 22.4655L10.8384 23.1792Z" fill="#F7F7F7"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M20.9614 12.5704L2.87684 12.5704L2.87684 11.6238L20.9614 11.6238L20.9614 12.5704Z" fill="#F7F7F7"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M1.05193 11.3759L10.8384 1.00001L11.4598 1.6588L1.00015 12.7484L1.05193 11.3759Z" fill="#F7F7F7"/>
					<path d="M1.00015 12.7484L10.8384 23.1792L11.5115 22.4655L1.05193 11.3759M1.00015 12.7484L1.05193 11.3759M1.00015 12.7484L11.4598 1.65879L10.8384 1.00001L1.05193 11.3759M2.87684 12.5704L20.9614 12.5704L20.9614 11.6238L2.87684 11.6238L2.87684 12.5704Z" stroke="#F7F7F7" stroke-width="1.10896"/>
				</svg>
				<svg class="cta-circle__next" width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M11.0845 1L20.9227 11.4308L20.8709 12.8033L10.4113 1.71369L11.0845 1Z" fill="#F7F7F7"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M0.961426 11.6088L19.046 11.6088V12.5554L0.961426 12.5554L0.961426 11.6088Z" fill="#F7F7F7"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M20.8709 12.8033L11.0845 23.1792L10.4631 22.5204L20.9227 11.4308L20.8709 12.8033Z" fill="#F7F7F7"/>
					<path d="M20.9227 11.4308L11.0845 1L10.4113 1.71369L20.8709 12.8033M20.9227 11.4308L20.8709 12.8033M20.9227 11.4308L10.4631 22.5204L11.0845 23.1792L20.8709 12.8033M19.046 11.6088L0.961426 11.6088L0.961426 12.5554L19.046 12.5554V11.6088Z" stroke="#F7F7F7" stroke-width="1.10896"/>
				</svg>`;

    ctaInner.innerHTML = svgs;
    ctaCircle.appendChild(ctaInner);
    postCard.appendChild(ctaCircle);

    // Using gsap.quickTo for fast updates
    const xSet = gsap.quickTo(ctaCircle, 'x', { duration: 0.2, ease: 'power3.out' });
    const ySet = gsap.quickTo(ctaCircle, 'y', { duration: 0.2, ease: 'power3.out' });
    let eHeight = postCard.offsetHeight;

    const handlePointerMove = (e) => {
        const rect = postCard.getBoundingClientRect();
        let y = e.clientY - rect.top - eHeight;
        let x = e.clientX - rect.left;

        xSet(x);
        ySet(y);
    };

    const handlePointerEnter = () => {
        ctaCircle.classList.add('active');
    };

    const handlePointerLeave = () => {
        ctaCircle.classList.remove('active');
    };

    // Add pointer event listeners
    postCard.addEventListener('pointermove', handlePointerMove);
    postCard.addEventListener('pointerenter', handlePointerEnter);
    postCard.addEventListener('pointerleave', handlePointerLeave);

    // Prevent default dragging behavior
    postCard.addEventListener('dragstart', (e) => e.preventDefault());

    // Set touch-action to none to prevent scrolling while dragging on touch devices
    postCard.style.touchAction = 'none';
}
